export default function () {

  const checkForVideo = () => {
    let cards = document.querySelector('.webex-cards');
    if (!cards || !window.location.hash.startsWith('#video:')) {
      return;
    }

    // video:webex-cards-storyblok-1 or video:https://www.youtube.com/embed/-QxJk1EkxVw

    let videoSelector = window.location.hash.replace(/^#video:/, '');
    if (videoSelector.startsWith('http')) {
      cards.querySelector(`a.btn[href*="${videoSelector}"]`)?.click() || console.warn(`Could not find video link ${videoSelector}`);
    } else {
      cards.querySelector(`#${videoSelector} a.btn[href*="video("]`)?.click() || console.warn(`Could not find video in #${videoSelector}`)
    }
  };

  window.removeEventListener('hashchange', checkForVideo);
  window.addEventListener('hashchange', checkForVideo);

  checkForVideo();

}